import React from 'react';
import { RefreshCwIcon, ShieldCheckIcon, HeartPulseIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const SERVICES = [{
  title: 'Prescription Refills',
  description: 'Quick and easy online refill requests with automatic notifications when your order is ready.',
  icon: <RefreshCwIcon className="w-8 h-8" data-id="element-275" data-mp="ia3042o4bo7c" />,
  link: '/prescriptions'
}, {
  title: 'Immunizations',
  description: 'Walk-in flu shots, COVID-19 boosters, and travel vaccinations administered by certified pharmacists.',
  icon: <ShieldCheckIcon className="w-8 h-8" data-id="element-276" data-mp="4bcwe46smqa0" />,
  link: '/immunizations'
}, {
  title: 'Health Consulting',
  description: 'One-on-one medication reviews and personalized wellness plans tailored to your health goals.',
  icon: <HeartPulseIcon className="w-8 h-8" data-id="element-277" data-mp="1ype1h6sxs9ij" />,
  link: '/health-consulting'
}];
export function ServicesGrid() {
  return <section className="py-16 md:py-24 bg-slate-50 border-y border-slate-100" data-id="element-278" data-mp="2xo7nmdy25b2a">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279" data-mp="2xqao5rwu6ml9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-280" data-mp="31qkr0vpc0wvw">
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-4 uppercase tracking-tight" data-id="element-281" data-mp="3gfqp2gcfoh27">
            Clinical Services
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto" data-id="element-282" data-mp="3lfleefgk8yl5">
            Beyond retail, we provide professional clinical care to support your
            long-term health and wellness.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-283" data-mp="38fhc55vsjdd">
          {SERVICES.map((service, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-284" data-mp="7ym6c64b25w5" data-mpi={idx}>
              <div className="w-16 h-16 rounded-2xl bg-white shadow-sm border border-slate-100 flex items-center justify-center text-clinical-blue mb-6" data-id="element-285" data-mp="3x61ozdzmw37">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-286" data-mp="3q8uw15nv2sgs">
                {service.title}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-6" data-id="element-287" data-mp="3gcrv234qwzvf">
                {service.description}
              </p>
              <Link to={service.link} className="text-clinical-blue text-sm font-bold flex items-center gap-1 hover:underline" data-id="element-288" data-mp="3c9v6lvsiy9jk">
                View Details <ChevronRightIcon className="w-4 h-4" data-id="element-289" data-mp="1mukjbxtqpqte" />
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}